import { REFRESH_SAAS_TICKET_TAGS } from "@/constants/event-bus";
import { getSaasDisputeTag } from "@/services/saas-dispute/allSessions";
import eventBus from "@/utils/eventBus";
import { useEffect, useState } from "react";
import { getSaasDisputeTicketConfig } from "@/services/saas-dispute/allSessions";

export default () => {
  const [allTags, setAllTags] = useState([]);
  const [allTagOptions, setAllTagOptions] = useState([]);
  const [saasTicketAiTag, setSaasTicketAiTag] = useState<string[]>([]);

  const fetchEmailTicketAiTag = async () => {


  }

  const initAllTagsAndOptions= async () => {
    // 修改为promise.all
    const [tags, { saas_ticket_ai_tag }] = await Promise.all([getSaasDisputeTag({}), getSaasDisputeTicketConfig()]);

    setAllTags(tags);
    setAllTagOptions(tags.map((item: { tag_name: string; id: number; }) => ({ label: item.tag_name, value: item.id })));
    setSaasTicketAiTag(saas_ticket_ai_tag);
  }

  useEffect(() => {
    // 监听事件总线，刷新标签
    eventBus.on(REFRESH_SAAS_TICKET_TAGS, initAllTagsAndOptions);
    eventBus.on(REFRESH_SAAS_TICKET_TAGS, fetchEmailTicketAiTag);
  }, [])


  return {
    initAllTagsAndOptions,
    allTags,
    allTagOptions,
    saasTicketAiTag
  }
}
